import type { ReactNode, SyntheticEvent } from 'react';

interface NoDragProps {
  children: ReactNode;
  className?: string;
}

/**
 * Wrapper component that prevents drag events from propagating.
 * React Flow already respects the 'nodrag' CSS class, but this ensures
 * all mouse/pointer events are properly stopped.
 */
export const NoDrag = ({ children, className = '' }: NoDragProps) => {
  const handleEvent = (event: SyntheticEvent) => {
    event.stopPropagation();
  };

  return (
    <div
      className={`nodrag ${className}`}
      onClick={handleEvent}
      onMouseDown={handleEvent}
      onPointerDown={handleEvent}
    >
      {children}
    </div>
  );
};


